import React, { useCallback, useContext, useState } from 'react';
import HeaderColumn from './HeaderColumn/HeaderColumn';
import { AppTableContext } from '../AppTableContext';
import { AppTableFilterPopover, EditFilter } from './AppTableFilterPopover/AppTableFilterPopover';
import { omitTopFixed } from '../helpers/helpers';
import { WMTableColumnShape } from '../WMTable/WMTable';

const AppTableHeader = ({
    headerData,
    disabled
}: {
    headerData: {
        cells: React.ReactNode[];
        columns: WMTableColumnShape[];
        headerIndex: number;
    };
    disabled: boolean;
}) => {
    const { data, sorting, filtersList, selectedIds, onTableDataChange } = useContext(AppTableContext);
    const [editFilter, setEditFilter] = useState<EditFilter | null>(null);

    const handleClose = useCallback(() => {
        setEditFilter(null);
    }, []);

    const onSortingChange = useCallback(
        (sorting: any) => {
            onTableDataChange?.({ sorting });
        },
        [onTableDataChange]
    );

    const checkedRows = data.filter(n => selectedIds?.has?.(n.id));
    const isAllChecked = !!data && data.length > 0 && !!checkedRows && checkedRows.length === data.length;
    const isSomeChecked = !!data && data.length > 0 && !!checkedRows && checkedRows.length > 1 && checkedRows.length < data.length;
    const isColumnFilterActive = useCallback(
        (column: WMTableColumnShape) => {
            return filtersList?.[column?.dataKey]?.some?.(filter => filter.checked);
        },
        [filtersList]
    );

    return (
        <>
            {filtersList && <AppTableFilterPopover editFilter={editFilter} onClose={handleClose} />}
            <>
                {headerData.columns.map((column, index) => (
                    <HeaderColumn
                        key={index}
                        sorting={sorting}
                        disabled={disabled}
                        onSortingChange={onSortingChange}
                        column={column}
                        data={data.filter(omitTopFixed)}
                        isFilterBoxOpen={editFilter?.dataKey === column.dataKey}
                        isSomeChecked={isSomeChecked}
                        isAllChecked={isAllChecked}
                        isColumnFilterActive={isColumnFilterActive}
                        setEditFilter={setEditFilter}
                        columnIndex={index}
                    />
                ))}
            </>
        </>
    );
};

export default AppTableHeader;
